import _objectWithoutProperties from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _possibleConstructorReturn from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/createClass";
import React, { Component } from 'react';
import { ua } from 'griffith-utils';
import cloneDeep from 'lodash/cloneDeep';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FragmentFetch =
/*#__PURE__*/
function () {
  function FragmentFetch(url, start, end, callback) {
    var _this = this;

    _classCallCheck(this, FragmentFetch);

    _defineProperty(this, "remove", function () {
      FragmentFetch.queue = FragmentFetch.queue.filter(function (item) {
        return item.start !== _this.start;
      });
    });

    this.start = start;
    FragmentFetch.queue.push(this);
    var xhr = new XMLHttpRequest();
    this.xhr = xhr;
    xhr.open('get', url);
    xhr.responseType = 'arraybuffer';
    xhr.setRequestHeader('Range', "bytes=".concat(start, "-").concat(end));

    xhr.onload = function () {
      if (xhr.status === 200 || xhr.status === 206) {
        callback(xhr.response);
      }

      _this.remove();
    };

    xhr.send();

    xhr.onerror = function () {
      _this.remove();
    };

    xhr.onabort = function () {
      _this.remove();
    };
  }

  _createClass(FragmentFetch, null, [{
    key: "clear",
    value: function clear() {
      while (FragmentFetch.queue.length) {
        var item = FragmentFetch.queue.shift();
        item.xhr.abort();
      }
    }
  }]);

  return FragmentFetch;
}();

_defineProperty(FragmentFetch, "queue", []);

var Stream =
/*#__PURE__*/
function () {
  function Stream(buffer) {
    _classCallCheck(this, Stream);

    this.buffer = buffer;
    this.position = 0;
  }

  _createClass(Stream, [{
    key: "readType",
    value: function readType() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
      var typeBuffer = [];

      for (var i = 0; i < length; i++) {
        typeBuffer.push(this.buffer[this.position++]);
      }

      return String.fromCharCode.apply(null, typeBuffer);
    }
  }, {
    key: "readByte",
    value: function readByte(length) {
      switch (length) {
        case 1:
          return this.readOneByte();

        case 2:
          return this.readTwoByte();

        case 3:
          return this.readThreeByte();

        case 4:
          return this.readFourByte();

        default:
          return 0;
      }
    }
  }, {
    key: "readOneByte",
    value: function readOneByte() {
      return this.buffer[this.position++] >>> 0;
    }
  }, {
    key: "readTwoByte",
    value: function readTwoByte() {
      return (this.buffer[this.position++] << 8 | this.buffer[this.position++]) >>> 0;
    }
  }, {
    key: "readThreeByte",
    value: function readThreeByte() {
      return (this.buffer[this.position++] << 16 | this.buffer[this.position++] << 8 | this.buffer[this.position++]) >>> 0;
    }
  }, {
    key: "readFourByte",
    value: function readFourByte() {
      return (this.buffer[this.position++] << 24 | this.buffer[this.position++] << 16 | this.buffer[this.position++] << 8 | this.buffer[this.position++]) >>> 0;
    }
  }]);

  return Stream;
}();

function ftyp(buffer) {
  var stream = new Stream(buffer);
  var majorBrand = stream.readType();
  var minorVersion = stream.readByte(4);
  var compatibleBrands = [];

  for (var i = stream.position; i < buffer.length; i += 4) {
    compatibleBrands.push(stream.readType(4));
  }

  var ftypBox = {
    majorBrand: majorBrand,
    minorVersion: minorVersion,
    compatibleBrands: compatibleBrands
  };
  return ftypBox;
}

function mvhd(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var creationTime = stream.readByte(4);
  var modificationTime = stream.readByte(4);
  var timescale = stream.readByte(4);
  var duration = stream.readByte(4);
  var rate = stream.readByte(4);
  var volume = stream.readByte(1); // reserved

  stream.readByte(3);
  stream.readByte(4);
  stream.readByte(4);
  var matrix = [];

  for (var i = 0; i < 36; i += 4) {
    matrix.push(stream.readByte(4));
  } // preDefined


  for (var _i = 0; _i < 24; _i += 4) {
    stream.readByte(4);
  }

  var nextTrackID = stream.readByte(4);
  var mvhdBox = {
    version: version,
    flags: flags,
    creationTime: creationTime,
    modificationTime: modificationTime,
    timescale: timescale,
    duration: duration,
    rate: rate,
    volume: volume,
    matrix: matrix,
    nextTrackID: nextTrackID
  };
  return mvhdBox;
}

function tkhd(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var creationTime = stream.readByte(4);
  var modificationTime = stream.readByte(4);
  var trackID = stream.readByte(4); // reserved

  stream.readByte(4);
  var duration = stream.readByte(4); // reserved

  stream.readByte(4);
  stream.readByte(4);
  var layer = stream.readByte(2);
  var alternateGroup = stream.readByte(2);
  var volume = stream.readByte(2); // reserved

  stream.readByte(2);
  var matrix = [];

  for (var i = 0; i < 36; i += 4) {
    matrix.push(stream.readByte(4));
  }

  var width = Number("".concat(stream.readByte(2), ".").concat(stream.readByte(2)));
  var height = Number("".concat(stream.readByte(2), ".").concat(stream.readByte(2)));
  var tkhdBox = {
    version: version,
    flags: flags,
    creationTime: creationTime,
    modificationTime: modificationTime,
    trackID: trackID,
    duration: duration,
    layer: layer,
    alternateGroup: alternateGroup,
    volume: volume,
    matrix: matrix,
    width: width,
    height: height
  };
  return tkhdBox;
}

function elst(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var entries = [];

  for (var i = 0; i < entryCount; ++i) {
    var segmentDuration = stream.readByte(4);
    var mediaTime = stream.readByte(4); // 0xffffffff -> -1

    if (mediaTime === 4294967295) {
      mediaTime = -1;
    }

    var mediaRateInteger = stream.readByte(2);
    var mediaRateFraction = stream.readByte(2);
    entries.push({
      segmentDuration: segmentDuration,
      mediaTime: mediaTime,
      mediaRateInteger: mediaRateInteger,
      mediaRateFraction: mediaRateFraction
    });
  }

  var elstBox = {
    version: version,
    flags: flags,
    entries: entries
  };
  return elstBox;
}

function mdhd(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var creationTime = stream.readByte(4);
  var modificationTime = stream.readByte(4);
  var timescale = stream.readByte(4);
  var duration = stream.readByte(4);
  var language = stream.readByte(2);
  var field = [];
  field[0] = language >> 10 & 0x1f;
  field[1] = language >> 5 & 0x1f;
  field[2] = language & 0x1f;
  var languageString = String.fromCharCode(0x60 + field[0], 0x60 + field[1], 0x60 + field[2]); // preDefined

  stream.readByte(2);
  var mdhdBox = {
    version: version,
    flags: flags,
    creationTime: creationTime,
    modificationTime: modificationTime,
    timescale: timescale,
    duration: duration,
    languageString: languageString
  };
  return mdhdBox;
}

function hdlr(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3); // preDefined

  stream.readByte(4);
  var handlerType = stream.readType().toString();
  var handlerType2 = stream.readType().toString(); // reserved

  stream.readByte(4);
  stream.readByte(4);
  var name = [];
  var c;

  while ((c = stream.readByte(1)) !== 0x00) {
    name.push(String.fromCharCode(c));
  }

  var hdlrBox = {
    version: version,
    flags: flags,
    handlerType: handlerType,
    handlerType2: handlerType2 || 0,
    name: name.join('')
  };
  return hdlrBox;
}

function vmhd(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var graphicsmode = stream.readByte(2);
  var opcolor = new Array(3).fill(stream.readByte(2));
  var vmhdBox = {
    version: version,
    flags: flags,
    graphicsmode: graphicsmode,
    opcolor: opcolor
  };
  return vmhdBox;
}

function dref(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var urlBox = [];
  var urlBuffer = stream.buffer.slice(8);
  var newStream = new Stream(urlBuffer);
  var MP4Box$1 = new MP4Box();

  for (var i = 0; i < entryCount; i++) {
    MP4Box$1.readSize(newStream);
    MP4Box$1.readType(newStream);
    MP4Box$1.readBody(newStream);
    urlBox.push(MP4Box$1.box);
  }

  var drefBox = {
    version: version,
    flags: flags,
    url: urlBox
  };
  return drefBox;
}

function url(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var urlBox = {
    version: version,
    flags: flags
  };
  return urlBox;
}

function stsd(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var box = [];
  var avc1Buffer = stream.buffer.slice(8);
  var newStream = new Stream(avc1Buffer);
  var MP4Box$1 = new MP4Box();
  var type = 'avc1';

  for (var i = 0; i < entryCount; i++) {
    MP4Box$1.readSize(newStream);
    MP4Box$1.readType(newStream);
    MP4Box$1.readBody(newStream);
    box.push(MP4Box$1.box);
    type = MP4Box$1.type;
  }

  var stsdBox = _defineProperty2({
    version: version,
    flags: flags
  }, type, box);

  return stsdBox;
}

function avc1(buffer) {
  var stream = new Stream(buffer); // reserved

  stream.readByte(4);
  stream.readByte(2);
  var dataReferenceIndex = stream.readByte(2); // preDefined

  stream.readByte(2); // reserved

  stream.readByte(2); // preDefined

  stream.readByte(4);
  stream.readByte(4);
  stream.readByte(4);
  var width = stream.readByte(2);
  var height = stream.readByte(2);
  var horizresolution = stream.readByte(4);
  var vertresolution = stream.readByte(4); // reserved

  stream.readByte(4);
  var frameCount = stream.readByte(2);
  var compressorname = stream.readType(32);
  var depth = stream.readByte(2); // preDefined

  stream.readByte(2);
  var avcCBuffer = stream.buffer.slice(78);
  var newStream = new Stream(avcCBuffer);
  var MP4Box$1 = new MP4Box();
  MP4Box$1.readSize(newStream);
  MP4Box$1.readType(newStream);
  MP4Box$1.readBody(newStream);
  var avcCBox = MP4Box$1.box;
  var avc1Box = {
    dataReferenceIndex: dataReferenceIndex,
    width: width,
    height: height,
    horizresolution: horizresolution,
    vertresolution: vertresolution,
    frameCount: frameCount,
    compressorname: compressorname,
    depth: depth,
    avcC: avcCBox
  };
  return avc1Box;
}

function avcC(buffer) {
  var stream = new Stream(buffer);
  var configurationVersion = stream.readByte(1);
  var AVCProfileIndication = stream.readByte(1);
  var profileCompatibility = stream.readByte(1);
  var AVCLevelIndication = stream.readByte(1);
  var lengthSizeMinusOne = stream.readByte(1) & 0x3;
  var numOfSequenceParameterSets = stream.readByte(1) & 31;
  var SPS = [];

  for (var i = 0; i < numOfSequenceParameterSets; i++) {
    var length = stream.readByte(2);
    SPS.push.apply(SPS, _toConsumableArray(stream.buffer.slice(stream.position, stream.position + length)));
    stream.position += length;
  }

  var numOfPictureParameterSets = stream.readByte(1);
  var PPS = [];

  for (var _i2 = 0; _i2 < numOfPictureParameterSets; _i2++) {
    var _length = stream.readByte(2);

    PPS.push.apply(PPS, _toConsumableArray(stream.buffer.slice(stream.position, stream.position + _length)));
    stream.position += _length;
  }

  var avcCBox = {
    configurationVersion: configurationVersion,
    AVCProfileIndication: AVCProfileIndication,
    profileCompatibility: profileCompatibility,
    AVCLevelIndication: AVCLevelIndication,
    lengthSizeMinusOne: lengthSizeMinusOne,
    SPS: SPS,
    PPS: PPS
  };
  return avcCBox;
}

function stts(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var samples = [];

  for (var i = 0; i < entryCount; i++) {
    var sampleCount = stream.readByte(4);
    var sampleDelta = stream.readByte(4);
    samples.push({
      sampleCount: sampleCount,
      sampleDelta: sampleDelta
    });
  }

  var sttsBox = {
    version: version,
    flags: flags,
    samples: samples
  };
  return sttsBox;
}

function stss(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var samples = [];

  for (var i = 0; i < entryCount; i++) {
    samples.push({
      sampleNumber: stream.readByte(4)
    });
  }

  var stssBox = {
    version: version,
    flags: flags,
    samples: samples
  };
  return stssBox;
}

function ctts(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var samples = [];

  for (var i = 0; i < entryCount; i++) {
    samples.push({
      sampleCount: stream.readByte(4),
      sampleOffset: stream.readByte(4)
    });
  }

  var cttsBox = {
    version: version,
    flags: flags,
    samples: samples
  };
  return cttsBox;
}

function mdhd$1(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var samples = [];

  for (var i = 0; i < entryCount; i++) {
    samples.push({
      firstChunk: stream.readByte(4),
      samplesPerChunk: stream.readByte(4),
      sampleDescriptionIndex: stream.readByte(4)
    });
  }

  var mdhdBox = {
    version: version,
    flags: flags,
    samples: samples
  };
  return mdhdBox;
}

function stss$1(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var sampleSize = stream.readByte(4);
  var sampleCount = stream.readByte(4);
  var samples = [];

  for (var i = 0; i < sampleCount; i++) {
    samples.push({
      entrySize: stream.readByte(4)
    });
  }

  var stssBox = {
    version: version,
    flags: flags,
    sampleSize: sampleSize,
    samples: samples
  };
  return stssBox;
}

function stco(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var entryCount = stream.readByte(4);
  var samples = [];

  for (var i = 0; i < entryCount; i++) {
    samples.push({
      chunkOffset: stream.readByte(4)
    });
  }

  var stcoBox = {
    version: version,
    flags: flags,
    samples: samples
  };
  return stcoBox;
}

function smhd(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var data = [];

  for (var i = 0; i < 4; i++) {
    data.push(stream.readByte(1));
  }

  var smhdBox = {
    version: version,
    flags: flags,
    data: data
  };
  return smhdBox;
}

function mp4a(buffer) {
  var stream = new Stream(buffer); // reserved

  stream.readByte(4);
  stream.readByte(2);
  var dataReferenceIndex = stream.readByte(2); // preDefined

  stream.readByte(2); // reserved

  stream.readByte(2); // preDefined

  stream.readByte(4);
  var channelCount = stream.readByte(2);
  var sampleSize = stream.readByte(2); // reserved

  stream.readByte(4);
  var sampleRate = stream.readByte(4) / (1 << 16);
  var esdsBuffer = stream.buffer.slice(28);
  var newStream = new Stream(esdsBuffer);
  var MP4Box$1 = new MP4Box();
  MP4Box$1.readSize(newStream);
  MP4Box$1.readType(newStream);
  MP4Box$1.readBody(newStream);
  var esdsBox = MP4Box$1.box;
  var mp4aBox = {
    dataReferenceIndex: dataReferenceIndex,
    channelCount: channelCount,
    sampleSize: sampleSize,
    sampleRate: sampleRate,
    esds: esdsBox
  };
  return mp4aBox;
}

var TAGS = [null, null, null, 'ESDescrTag', 'DecoderConfigDescrTag', 'DecSpecificDescrTag'];

function esds(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var type = TAGS[stream.readByte(1)];

  var esdsBox = _defineProperty2({
    version: version,
    flags: flags
  }, type, getESDescrTag(stream));

  return esdsBox;
}

function getESDescrTag(stream) {
  var data = {};
  var size = stream.readByte(1);

  if (size === 0x80) {
    stream.readByte(2);
    size = stream.readByte(1) + 5;
  } else {
    size += 2;
  }

  data.size = size;
  data.ESID = stream.readByte(2);
  data.streamPriority = stream.readByte(1);
  data[TAGS[stream.readByte(1)]] = getDecoderConfigDescrTag(stream);
  data[TAGS[stream.readByte(1)]] = getDecSpecificDescrTag(stream);
  return data;
}

function getDecoderConfigDescrTag(stream) {
  var data = {};
  var size = stream.readByte(1);

  if (size === 0x80) {
    stream.readByte(2);
    size = stream.readByte(1) + 5;
  } else {
    size += 2;
  }

  data.size = size;
  data.objectTypeIndication = stream.readByte(1);
  var type = stream.readByte(1);
  data.streamType = type & (1 << 7) - 1;
  data.upStream = type & 1 << 1;
  data.bufferSize = stream.readByte(3);
  data.maxBitrate = stream.readByte(4);
  data.avgBitrate = stream.readByte(4);
  return data;
}

function getDecSpecificDescrTag(stream) {
  var data = {};
  var size = stream.readByte(1);
  var dataSize = size;

  if (size === 0x80) {
    stream.readByte(2);
    size = stream.readByte(1) + 5;
    dataSize = size - 5;
  } else {
    size += 2;
  }

  data.size = size;
  var EScode = [];

  for (var i = 0; i < dataSize; i++) {
    EScode.push(Number(stream.readByte(1)).toString(16).padStart(2, '0'));
  }

  data.audioConfig = EScode.map(function (item) {
    return Number("0x".concat(item));
  });
  return data;
}

function meta(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var metaBox = {
    version: version,
    flags: flags
  };
  return metaBox;
}

function mdat(buffer) {
  var stream = new Stream(buffer);
  var data = stream.buffer.subarray(stream.position, stream.buffer.length);
  var mdatBox = {
    data: data
  };
  return mdatBox;
}

function sdtp(buffer) {
  var stream = new Stream(buffer);
  var version = stream.readByte(1);
  var flags = stream.readByte(3);
  var samplesFlag = [];

  for (var i = stream.position; i < buffer.length; i++) {
    var tmpByte = stream.readByte(1);
    samplesFlag.push({
      isLeading: tmpByte >> 6,
      dependsOn: tmpByte >> 4 & 0x3,
      isDepended: tmpByte >> 2 & 0x3,
      hasRedundancy: tmpByte & 0x3
    });
  }

  var sdtpBox = {
    version: version,
    flags: flags,
    samplesFlag: samplesFlag
  };
  return sdtpBox;
}

function thmb(buffer) {
  var stream = new Stream(buffer);
  var data = stream.readByte(buffer.length);
  var thmbBox = {
    data: data
  };
  return thmbBox;
}

var boxParse = {
  ftyp: ftyp,
  mvhd: mvhd,
  tkhd: tkhd,
  elst: elst,
  mdhd: mdhd,
  hdlr: hdlr,
  vmhd: vmhd,
  dref: dref,
  'url ': url,
  stsd: stsd,
  avc1: avc1,
  avcC: avcC,
  stts: stts,
  stss: stss,
  ctts: ctts,
  stsc: mdhd$1,
  stsz: stss$1,
  stco: stco,
  smhd: smhd,
  mp4a: mp4a,
  esds: esds,
  meta: meta,
  mdat: mdat,
  sdtp: sdtp,
  thmb: thmb
};
var CONTAINER_BOXES = ['moov', 'trak', 'edts', 'mdia', 'minf', 'dinf', 'stbl'];
var SPECIAL_BOXES = ['udta', 'free'];

var MP4Box =
/*#__PURE__*/
function () {
  function MP4Box() {
    _classCallCheck(this, MP4Box);

    this.size = 0;
    this.type = '';
    this.start = 0;
    this.box = {};
  }

  _createClass(MP4Box, [{
    key: "readSize",
    value: function readSize(stream) {
      this.start = stream.position;
      this.size = stream.readByte(4);
    }
  }, {
    key: "readType",
    value: function readType(stream) {
      this.type = stream.readType(); // 一个 box 的 size 只可能大于等于 8
      // 如果从 readSize 中解析出来的 mdat size 为 1，则表明此视频比较大，需要 type 后的 8 个字节来计算实际大小

      if (this.size === 1) {
        this.size = stream.readByte(4) << 32;
        this.size |= stream.readByte(4);
      }
    }
  }, {
    key: "readBody",
    value: function readBody(stream) {
      var _this2 = this;

      this.data = stream.buffer.slice(stream.position, this.size + this.start);

      if (CONTAINER_BOXES.find(function (item) {
        return item === _this2.type;
      }) || SPECIAL_BOXES.find(function (item) {
        return item === _this2.type;
      })) {
        this.parserContainerBox();
      } else {
        if (!boxParse[this.type]) {
          this.box = {};
        } else {
          this.box = _objectSpread({}, this.box, {}, boxParse[this.type](this.data));
        }
      }

      stream.position += this.data.length;
    }
  }, {
    key: "parserContainerBox",
    value: function parserContainerBox() {
      var stream = new Stream(this.data);
      var size = stream.buffer.length;

      while (stream.position < size) {
        var Box = new MP4Box();
        Box.readSize(stream);
        Box.readType(stream);
        Box.readBody(stream);

        if (Box.type === 'trak' && Box.box.mdia && Box.box.mdia.hdlr) {
          var handlerType = Box.box.mdia.hdlr.handlerType;

          if (handlerType === 'vide') {
            this.box.videoTrak = Box.box;
          } else if (handlerType === 'soun') {
            this.box.audioTrak = Box.box;
          } else {
            this.box["".concat(handlerType, "Trak")] = Box.box;
          }
        } else {
          this.box[Box.type] = Box.box;
        }
      }
    }
  }]);

  return MP4Box;
}();

var MP4Parse =
/*#__PURE__*/
function () {
  function MP4Parse(buffer) {
    _classCallCheck(this, MP4Parse);

    this.buffer = buffer;
    this.stream = new Stream(buffer);
    this.mp4BoxTreeObject = {};
    this.init();
  }

  _createClass(MP4Parse, [{
    key: "init",
    value: function init() {
      this.parse();
    }
  }, {
    key: "parse",
    value: function parse() {
      while (this.stream.position < this.buffer.length) {
        var MP4Box$1 = new MP4Box();
        MP4Box$1.readSize(this.stream);
        MP4Box$1.readType(this.stream);
        MP4Box$1.readBody(this.stream);
        this.mp4BoxTreeObject[MP4Box$1.type] = MP4Box$1.box;
        this.mp4BoxTreeObject[MP4Box$1.type].size = MP4Box$1.size;
      }
    }
  }]);

  return MP4Parse;
}();

function findBox(mp4BoxTree, type) {
  switch (type) {
    case 'moov':
      return findMoovBox(mp4BoxTree);

    case 'mvhd':
      return findMvhdBox(mp4BoxTree);

    case 'videoTrak':
      return findVideoTrakBox(mp4BoxTree);

    case 'audioTrak':
      return findAudioTrakBox(mp4BoxTree);

    case 'videoTkhd':
      return findVideoTkhdBox(mp4BoxTree);

    case 'audioTkhd':
      return findAudioTkhdBox(mp4BoxTree);

    case 'videoStbl':
      return findVideoStblBox(mp4BoxTree);

    case 'audioStbl':
      return findAudioStblBox(mp4BoxTree);

    case 'videoStsc':
      return findVideoStscBox(mp4BoxTree);

    case 'audioStsc':
      return findAudioStscBox(mp4BoxTree);

    case 'avcC':
      return findAvcCBox(mp4BoxTree);

    case 'esds':
      return findEsdsBox(mp4BoxTree);

    case 'videoStco':
      return findVideoStcoBox(mp4BoxTree);

    case 'audioStco':
      return findAudioStcoBox(mp4BoxTree);

    case 'videoStts':
      return findVideoSttsBox(mp4BoxTree);

    case 'audioStts':
      return findAudioSttsBox(mp4BoxTree);

    case 'audioMdhd':
      return findAudioMdhdBox(mp4BoxTree);

    case 'videoMdhd':
      return findVideoMdhdBox(mp4BoxTree);

    case 'videoStss':
      return findVideoStssBox(mp4BoxTree);

    case 'videoStsz':
      return findVideoStszBox(mp4BoxTree);

    case 'videoCtts':
      return findVideoCttsBox(mp4BoxTree);

    case 'audioStsz':
      return findAudioStszBox(mp4BoxTree);

    case 'mp4a':
      return findMp4aBox(mp4BoxTree);

    case 'audioElst':
      return findAudioElstBox(mp4BoxTree);

    case 'videoElst':
      return findVideoElstBox(mp4BoxTree);

    default:
      return {};
  }
}

function findMoovBox(mp4BoxTree) {
  return mp4BoxTree['moov'];
}

function findMvhdBox(mp4BoxTree) {
  return findMoovBox(mp4BoxTree)['mvhd'];
}

function findVideoTrakBox(mp4BoxTree) {
  return findMoovBox(mp4BoxTree)['videoTrak'];
}

function findVideoTkhdBox(mp4BoxTree) {
  return findVideoTrakBox(mp4BoxTree)['tkhd'];
}

function findVideoStblBox(mp4BoxTree) {
  return findVideoTrakBox(mp4BoxTree)['mdia']['minf']['stbl'];
}

function findAudioTrakBox(mp4BoxTree) {
  return findMoovBox(mp4BoxTree)['audioTrak'];
}

function findAudioStblBox(mp4BoxTree) {
  return findAudioTrakBox(mp4BoxTree)['mdia']['minf']['stbl'];
}

function findAudioTkhdBox(mp4BoxTree) {
  return findAudioTrakBox(mp4BoxTree)['tkhd'];
}

function findVideoStscBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['stsc'];
}

function findAudioStscBox(mp4BoxTree) {
  return findAudioStblBox(mp4BoxTree)['stsc'];
}

function findAvcCBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['stsd']['avc1'][0]['avcC'];
}

function findMp4aBox(mp4BoxTree) {
  return findAudioStblBox(mp4BoxTree)['stsd']['mp4a'][0];
}

function findEsdsBox(mp4BoxTree) {
  return findMp4aBox(mp4BoxTree)['esds'];
}

function findVideoStcoBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['stco'];
}

function findAudioStcoBox(mp4BoxTree) {
  return findAudioStblBox(mp4BoxTree)['stco'];
}

function findVideoSttsBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['stts'];
}

function findAudioSttsBox(mp4BoxTree) {
  return findAudioStblBox(mp4BoxTree)['stts'];
}

function findVideoMdhdBox(mp4BoxTree) {
  return findVideoTrakBox(mp4BoxTree)['mdia']['mdhd'];
}

function findAudioMdhdBox(mp4BoxTree) {
  return findAudioTrakBox(mp4BoxTree)['mdia']['mdhd'];
}

function findVideoStssBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['stss'];
}

function findVideoStszBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['stsz'];
}

function findAudioStszBox(mp4BoxTree) {
  return findAudioStblBox(mp4BoxTree)['stsz'];
}

function findVideoCttsBox(mp4BoxTree) {
  return findVideoStblBox(mp4BoxTree)['ctts'];
}

function findAudioElstBox(mp4BoxTree) {
  return findAudioTrakBox(mp4BoxTree)['edts']['elst'];
}

function findVideoElstBox(mp4BoxTree) {
  return findAudioTrakBox(mp4BoxTree)['edts']['elst'];
}

function getSamplesOffset(stszBox, stscBoxSamplesPerChunkArray) {
  var samplesOffset = [];

  for (var i = 0, j = 0; i < stscBoxSamplesPerChunkArray.length; i++) {
    if (i + j >= stszBox.samples.length) {
      break;
    }

    samplesOffset.push(stszBox.samples[i + j].entrySize);

    if (stscBoxSamplesPerChunkArray[i] !== 1) {
      for (var flag = 1; flag < stscBoxSamplesPerChunkArray[i]; flag++) {
        var offset = stszBox.samples[i + flag + j].entrySize + samplesOffset[i + flag - 1 + j];
        samplesOffset.push(offset);
      }

      j = j + stscBoxSamplesPerChunkArray[i] - 1;
    }
  }

  return samplesOffset;
}

function getPerChunkArray(stscBox, end) {
  var stscBoxSamplesPerChunkArray = [];
  var stscSamplesLength = stscBox.samples.length; // stsc box
  // firstChunk         1  3  6  7
  // samplesPerChunk    1  2  1  2
  // ↓
  // [1,1,2,2,2,1,2,2]

  for (var i = 0; i < end; i++) {
    if (i !== 0 && i < stscSamplesLength && stscBox.samples[i].firstChunk - 1 !== stscBox.samples[i - 1].firstChunk) {
      i--;
      stscBox.samples[i].firstChunk++;
    } // 处理最后一位不是 end 时的情况


    if (i >= stscSamplesLength) {
      if (stscBox.samples[stscSamplesLength - 1] !== 1) {
        i = i + stscBox.samples[stscSamplesLength - 1].samplesPerChunk - 1;
      }

      stscBoxSamplesPerChunkArray.push(stscBox.samples[stscSamplesLength - 1].samplesPerChunk);
    } else {
      stscBoxSamplesPerChunkArray.push(stscBox.samples[i].samplesPerChunk);
    }
  }

  return stscBoxSamplesPerChunkArray;
}

function getFragmentPosition(videoSamples, audioSamples, mdatStart, isLastFragmentPosition) {
  var videoSamplesEnd = videoSamples[videoSamples.length - 1].end;
  var videoSamplesStart = 0;

  if (videoSamples.length > 0) {
    videoSamplesStart = videoSamples[0].start;
  } // maybe the last GOP dont have audio track
  // 最后一个 GOP 序列可能没有音频轨


  var audioSamplesEnd = 0;
  var audioSamplesStart = Number.MAX_SAFE_INTEGER;

  if (audioSamples.length !== 0) {
    audioSamplesEnd = audioSamples[audioSamples.length - 1].end;
    audioSamplesStart = audioSamples[0].start;
  }

  var fragmentEndPosition = isLastFragmentPosition ? '' : Math.max(videoSamplesEnd, audioSamplesEnd) + mdatStart;
  var fragmentStartPosition = Math.min(videoSamplesStart, audioSamplesStart) + mdatStart;
  return [fragmentStartPosition, fragmentEndPosition];
}

function getBufferStart(mp4BoxTree) {
  var videoOffsetStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var audioOffsetStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.min(getChunkSize(mp4BoxTree, videoOffsetStart, 'video'), getChunkSize(mp4BoxTree, audioOffsetStart, 'audio'));
}

function getChunkSize(mp4BoxTree, offsetStart, type) {
  var stscBox = cloneDeep(findBox(mp4BoxTree, type === 'video' ? 'videoStsc' : 'audioStsc'));
  var newOffsetStart = 0;
  var stscBoxSamplesPerChunkArray = getPerChunkArray(stscBox, offsetStart);
  var chunkIndex = 0;

  for (var i = 0; offsetStart > 0 && i <= stscBoxSamplesPerChunkArray.length; i++) {
    newOffsetStart += stscBoxSamplesPerChunkArray[i];

    if (newOffsetStart === offsetStart) {
      chunkIndex = i + 1;
      break;
    } else if (newOffsetStart > offsetStart) {
      newOffsetStart -= stscBoxSamplesPerChunkArray[i];
      chunkIndex = i;
      break;
    }
  }

  var sampleInterval = [newOffsetStart, offsetStart];
  var stszBox = findBox(mp4BoxTree, type === 'video' ? 'videoStsz' : 'audioStsz');
  var sampleSize = 0; // 考虑到 stsc 不为 1 的情况

  var samples = stszBox.samples.slice(sampleInterval[0], sampleInterval[1]);

  for (var _i3 = 0; _i3 < samples.length; _i3++) {
    sampleSize += samples[_i3].entrySize;
  }

  var stcoBox = findBox(mp4BoxTree, type === 'video' ? 'videoStco' : 'audioStco'); // 如果最后一个 GOP 没有音频轨，BufferStart 需要按照视频轨来计算。
  // If the last GOP dont have audio track, we should ignore the audio chunk size.

  if (chunkIndex >= stcoBox.samples.length) {
    return Number.MAX_SAFE_INTEGER;
  }

  return stcoBox.samples[chunkIndex].chunkOffset + sampleSize;
}

function getVideoSamples(mp4BoxTree, bufferStart, offsetInterVal) {
  var cttsBox = cloneDeep(findBox(mp4BoxTree, 'videoCtts'));
  var compositionTimeOffset = [];

  if (cttsBox) {
    for (var i = 0; i < cttsBox.samples.length; i++) {
      compositionTimeOffset.push(cttsBox.samples[i].sampleOffset);

      if (cttsBox.samples[i].sampleCount !== 1) {
        cttsBox.samples[i].sampleCount--;
        i--;
      }
    }
  }

  return getSamples(mp4BoxTree, bufferStart, offsetInterVal, compositionTimeOffset);
}

function getAudioSamples(mp4BoxTree, bufferStart, offsetInterVal) {
  return getSamples(mp4BoxTree, bufferStart, offsetInterVal);
}

function getSamples(mp4BoxTree, bufferStart, _ref, compositionTimeOffset) {
  var _ref2 = _slicedToArray(_ref, 2),
      offsetStart = _ref2[0],
      offsetEnd = _ref2[1];

  var samples = [];
  var sttsBox = findBox(mp4BoxTree, compositionTimeOffset ? 'videoStts' : 'audioStts');
  var stszBox = findBox(mp4BoxTree, compositionTimeOffset ? 'videoStsz' : 'audioStsz');
  var stcoBox = findBox(mp4BoxTree, compositionTimeOffset ? 'videoStco' : 'audioStco');
  var stscBox = cloneDeep(findBox(mp4BoxTree, compositionTimeOffset ? 'videoStsc' : 'audioStsc'));
  var stscBoxSamplesPerChunkArray = getPerChunkArray(stscBox, offsetEnd);
  var samplesOffset = getSamplesOffset(stszBox, stscBoxSamplesPerChunkArray);
  var sttsFormatBox = [];

  for (var i = 0; i < sttsBox.samples.length; i++) {
    var _sttsBox$samples$i = sttsBox.samples[i],
        sampleCount = _sttsBox$samples$i.sampleCount,
        sampleDelta = _sttsBox$samples$i.sampleDelta;
    sttsFormatBox.push({
      sampleCount: sampleCount + (sttsFormatBox[i - 1] ? sttsFormatBox[i - 1].sampleCount : 0),
      sampleDelta: sampleDelta
    });
  } // 算法不太好，可以和下面 for 循环结合，用双指针来做
  // FIXME


  var chunkOffsetArray = [];

  for (var _i4 = 0; _i4 < stscBoxSamplesPerChunkArray.length; _i4++) {
    for (var j = 0; j < stscBoxSamplesPerChunkArray[_i4]; j++) {
      var sample = stcoBox.samples[_i4];
      chunkOffsetArray.push(sample ? sample.chunkOffset : stcoBox.samples[stcoBox.samples.length - 1].chunkOffset);
    }
  }

  var _loop = function _loop(_i5) {
    var size = stszBox.samples[_i5].entrySize;
    var end = chunkOffsetArray[_i5] - bufferStart + samplesOffset[_i5];
    var start = end - size;
    var duration = sttsFormatBox.find(function (sample, idx) {
      if (sttsFormatBox[idx - 1]) {
        return _i5 + 1 <= sample.sampleCount && _i5 + 1 > sttsFormatBox[idx - 1].sampleCount;
      } else {
        return _i5 + 1 <= sample.sampleCount;
      }
    }).sampleDelta;
    samples.push(_objectSpread({}, compositionTimeOffset && {
      compositionTimeOffset: compositionTimeOffset.length ? compositionTimeOffset[_i5] : 0
    }, {
      duration: duration,
      size: size,
      start: start,
      end: end,
      bufferStart: bufferStart
    }));
  };

  for (var _i5 = offsetStart; _i5 < offsetEnd; _i5++) {
    _loop(_i5);
  }

  return samples;
}

function getVideoSamplesInterval(mp4BoxTree) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var stssBox = cloneDeep(findBox(mp4BoxTree, 'videoStss'));
  var sttsBox = cloneDeep(findBox(mp4BoxTree, 'videoStts'));
  var stszBox = findBox(mp4BoxTree, 'videoStsz');
  var duration = getDuration(sttsBox, stszBox.samples.length);
  var intervalArray = getIntervalArray(stssBox, stszBox);
  var timeInterval = intervalArray.map(function (interval) {
    return getDuration(sttsBox, interval);
  });
  var interval = {
    offsetInterVal: [],
    timeInterVal: []
  };

  for (var i = 0; i < timeInterval.length; i++) {
    var start = timeInterval[i];
    var end = timeInterval[i + 1] ? timeInterval[i + 1] : duration;

    if (start <= time && time < end) {
      var offsetStart = intervalArray[i];
      var offsetEnd = intervalArray[i + 1] !== undefined ? intervalArray[i + 1] : stszBox.samples.length;
      interval.offsetInterVal.push(offsetStart, offsetEnd);
      interval.timeInterVal.push(start, end);
      break;
    }
  }

  return interval;
}

function getAudioSamplesInterval(mp4BoxTree, videoInterval) {
  var _videoInterval$timeIn = _slicedToArray(videoInterval.timeInterVal, 2),
      startTime = _videoInterval$timeIn[0],
      endTime = _videoInterval$timeIn[1],
      offsetInterVal = videoInterval.offsetInterVal;

  var sttsBox = cloneDeep(findBox(mp4BoxTree, 'audioStts'));

  var _findBox = findBox(mp4BoxTree, 'audioMdhd'),
      audioTimescale = _findBox.timescale;

  var _findBox2 = findBox(mp4BoxTree, 'videoMdhd'),
      videoTimescale = _findBox2.timescale;

  var videoStszBox = findBox(mp4BoxTree, 'videoStsz');
  var audioStszBox = findBox(mp4BoxTree, 'audioStsz');
  var audioElstBox = findBox(mp4BoxTree, 'audioElst');
  var audioStartTime = startTime / videoTimescale * audioTimescale;
  var audioEndTime = endTime / videoTimescale * audioTimescale;
  var start = 0;
  var end = 0;
  var _audioElstBox$entries = audioElstBox.entries[0],
      mediaTime = _audioElstBox$entries.mediaTime,
      segmentDuration = _audioElstBox$entries.segmentDuration;
  var startDuration = mediaTime !== -1 ? mediaTime : segmentDuration;
  var endDuration = 0;

  for (var i = 0; i < sttsBox.samples.length; i++) {
    var _sttsBox$samples$i2 = sttsBox.samples[i],
        sampleCount = _sttsBox$samples$i2.sampleCount,
        sampleDelta = _sttsBox$samples$i2.sampleDelta;

    for (var j = 0; j < sampleCount; j++) {
      if (startDuration <= audioStartTime && audioStartTime !== 0) {
        startDuration += sampleDelta;
        start++;
      }

      if (endDuration <= audioEndTime) {
        endDuration += sampleDelta;
        end++;
      }
    }
  } // 如果是 video 的最后一个片段，也就是 audio 的最有一个片段
  // 使用 stsz 的长度来判断


  var audioEnd;

  if (offsetInterVal[1] === videoStszBox.samples.length) {
    audioEnd = audioStszBox.samples.length;
  }

  var interval = {
    offsetInterVal: [start, audioEnd ? audioEnd : end],
    timeInterVal: [startDuration, endDuration]
  };
  return interval;
}

function getNextVideoSamplesInterval(mp4BoxTree, sample) {
  var stssBox = cloneDeep(findBox(mp4BoxTree, 'videoStss'));
  var sttsBox = cloneDeep(findBox(mp4BoxTree, 'videoStts'));
  var stszBox = findBox(mp4BoxTree, 'videoStsz');
  var sampleCount = stszBox.samples.length;
  var duration = getDuration(sttsBox, sampleCount);
  var intervalArray = getIntervalArray(stssBox, stszBox);
  var timeInterval = intervalArray.map(function (interval) {
    return getDuration(sttsBox, interval);
  });
  var result = [];

  if (sample + 1 > intervalArray[intervalArray.length - 1]) {
    result = {
      offsetInterVal: [intervalArray[intervalArray.length - 1], sampleCount],
      timeInterVal: [timeInterval[intervalArray.length - 1], duration]
    };
  }

  for (var i = 0; i < intervalArray.length; i++) {
    if (intervalArray[i] < sample + 1 && intervalArray[i + 1] >= sample + 1) {
      result = {
        offsetInterVal: [intervalArray[i], intervalArray[i + 1]],
        timeInterVal: [timeInterval[i], timeInterval[i + 1]]
      };
      break;
    }
  }

  return result;
}

function getIntervalArray(stssBox, stszBox) {
  var intervalArray = [];

  if (stssBox) {
    intervalArray = stssBox.samples.map(function (sample) {
      return sample.sampleNumber - 1;
    });
  } else {
    // make a fake GOP when video dont have B/P frame
    for (var i = 0; i <= Math.floor(stszBox.samples.length / 5); i++) {
      intervalArray.push(i * 5);
    }
  }

  return intervalArray;
}

function getVideoTrackInfo(videoSamples, mdatBuffer) {
  return {
    samples: videoSamples.map(function (sample) {
      return _objectSpread({}, sample, {
        buffer: mdatBuffer.slice(sample.start, sample.end)
      });
    }),
    trackId: 1
  };
}

function getAudioTrackInfo(audioSamples, mdatBuffer) {
  return {
    samples: audioSamples.map(function (sample) {
      return _objectSpread({}, sample, {
        buffer: mdatBuffer.slice(sample.start, sample.end)
      });
    }),
    trackId: 2
  };
}

function getDuration(sttsBox, totalCount) {
  var count = 0;
  var duration = 0;

  for (var i = 0; i < sttsBox.samples.length; i++) {
    var _sttsBox$samples$i3 = sttsBox.samples[i],
        sampleCount = _sttsBox$samples$i3.sampleCount,
        sampleDelta = _sttsBox$samples$i3.sampleDelta;

    for (var j = 0; j < sampleCount; j++) {
      if (count < totalCount && totalCount !== 0) {
        duration += sampleDelta;
        count++;
      } else {
        return duration;
      }
    }
  }

  return duration;
}

var MP4Probe =
/*#__PURE__*/
function () {
  function MP4Probe(mp4BoxTree) {
    var _this3 = this;

    _classCallCheck(this, MP4Probe);

    _defineProperty(this, "updateInterval", function (time) {
      var _this3$mp4Data = _this3.mp4Data,
          videoTimescale = _this3$mp4Data.videoTimescale,
          audioTimescale = _this3$mp4Data.audioTimescale;

      if (typeof time === 'number') {
        _this3.videoInterval = getVideoSamplesInterval(_this3.mp4BoxTree, time * videoTimescale);
      } else {
        _this3.videoInterval = getNextVideoSamplesInterval(_this3.mp4BoxTree, _this3.videoInterval.offsetInterVal[1]);
      }

      _this3.audioInterval = getAudioSamplesInterval(_this3.mp4BoxTree, _this3.videoInterval);

      var videoTimeRange = _this3.videoInterval.timeInterVal.map(function (time) {
        return time / videoTimescale;
      });

      var audioTimeRange = _this3.audioInterval.timeInterVal.map(function (time) {
        return time / audioTimescale;
      });

      _this3.timeRange = [Math.min(videoTimeRange[0], audioTimeRange[0]), Math.max(videoTimeRange[1], audioTimeRange[1])];
    });

    _defineProperty(this, "isDraining", function (time) {
      return time > (_this3.timeRange[1] - _this3.timeRange[0]) / 4 + _this3.timeRange[0];
    });

    _defineProperty(this, "getFragmentPosition", function (time) {
      _this3.updateInterval(time);

      _this3.bufferStart = getBufferStart(_this3.mp4BoxTree, _this3.videoInterval.offsetInterVal[0], _this3.audioInterval.offsetInterVal[0]);

      var _this3$getSamples = _this3.getSamples(),
          videoSamples = _this3$getSamples.videoSamples,
          audioSamples = _this3$getSamples.audioSamples;

      var stcoBox = findBox(_this3.mp4BoxTree, 'videoStco');
      var videoSamplesStart = 0;

      if (videoSamples.length > 0) {
        videoSamplesStart = videoSamples[videoSamples.length - 1].start;
      }

      var isLastFragmentPosition = videoSamplesStart + videoSamples[videoSamples.length - 1].bufferStart === stcoBox.samples[stcoBox.samples.length - 1].chunkOffset;
      return getFragmentPosition(videoSamples, audioSamples, _this3.bufferStart, isLastFragmentPosition);
    });

    _defineProperty(this, "getSamples", function () {
      var videoSamples = getVideoSamples(_this3.mp4BoxTree, _this3.bufferStart, _this3.videoInterval.offsetInterVal);
      var audioSamples = getAudioSamples(_this3.mp4BoxTree, _this3.bufferStart, _this3.audioInterval.offsetInterVal);
      return {
        videoSamples: videoSamples,
        audioSamples: audioSamples
      };
    });

    _defineProperty(this, "getTrackInfo", function (mdatBuffer) {
      var _this3$getSamples2 = _this3.getSamples(),
          videoSamples = _this3$getSamples2.videoSamples,
          audioSamples = _this3$getSamples2.audioSamples;

      var videoTrackInfo = getVideoTrackInfo(videoSamples, mdatBuffer);
      var audioTrackInfo = getAudioTrackInfo(audioSamples, mdatBuffer);
      return {
        videoTrackInfo: videoTrackInfo,
        audioTrackInfo: audioTrackInfo
      };
    });

    this.mp4BoxTree = mp4BoxTree;
    this.mp4Data = {};
    this.init();
  }

  _createClass(MP4Probe, [{
    key: "init",
    value: function init() {
      this.getMP4Data();
    }
  }, {
    key: "getMP4Data",
    value: function getMP4Data() {
      var _findBox3 = findBox(this.mp4BoxTree, 'mvhd'),
          duration = _findBox3.duration,
          timescale = _findBox3.timescale;

      var _findBox4 = findBox(this.mp4BoxTree, 'mp4a'),
          channelCount = _findBox4.channelCount,
          sampleRate = _findBox4.sampleRate;

      var _findBox5 = findBox(this.mp4BoxTree, 'audioMdhd'),
          audioTimescale = _findBox5.timescale,
          audioDuration = _findBox5.duration;

      var _findBox6 = findBox(this.mp4BoxTree, 'esds'),
          audioConfig = _findBox6.ESDescrTag.DecSpecificDescrTag.audioConfig;

      this.mp4Data = {
        duration: duration,
        timescale: timescale,
        channelCount: channelCount,
        sampleRate: sampleRate,
        audioConfig: audioConfig,
        audioDuration: audioDuration,
        audioTimescale: audioTimescale
      };
      var hasVideoStream = findBox(this.mp4BoxTree, 'videoTrak');

      if (hasVideoStream) {
        var _findBox7 = findBox(this.mp4BoxTree, 'videoTkhd'),
            width = _findBox7.width,
            height = _findBox7.height;

        var _findBox8 = findBox(this.mp4BoxTree, 'videoStsz'),
            samples = _findBox8.samples;

        var _findBox9 = findBox(this.mp4BoxTree, 'avcC'),
            SPS = _findBox9.SPS,
            PPS = _findBox9.PPS;

        var _findBox10 = findBox(this.mp4BoxTree, 'videoMdhd'),
            videoTimescale = _findBox10.timescale,
            videoDuration = _findBox10.duration;

        this.mp4Data = _objectSpread({}, this.mp4Data, {
          width: width,
          height: height,
          SPS: SPS,
          PPS: PPS,
          videoDuration: videoDuration,
          videoTimescale: videoTimescale,
          videoSamplesLength: samples.length
        });
      }
    }
  }]);

  return MP4Probe;
}();

function generateVersionAndFlags(version, flag) {
  return new Uint8Array([version & 0xff, flag >> 16 & 0xff, flag >> 8 & 0xff, flag & 0xff]);
}

function concatTypedArray() {
  var totalLength = 0;

  for (var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++) {
    arrays[_key] = arguments[_key];
  }

  for (var _i6 = 0, _arrays = arrays; _i6 < _arrays.length; _i6++) {
    var arr = _arrays[_i6];
    totalLength += arr.length;
  }

  var result = new Uint8Array(totalLength);
  var offset = 0;

  for (var _i7 = 0, _arrays2 = arrays; _i7 < _arrays2.length; _i7++) {
    var _arr = _arrays2[_i7];
    result.set(_arr, offset);
    offset += _arr.length;
  }

  return result;
}

function generateBox(type, content) {
  return concatTypedArray(num2FourBytes(content.length + 8), str2TypedArray(type), content);
}

var char2Hex = function char2Hex(char) {
  return char.charCodeAt();
};

var str2TypedArray = function str2TypedArray(str) {
  // 字符串转 uint8 array
  return new Uint8Array(Array.prototype.map.call(str, char2Hex));
};

function generatePredefined(length) {
  return generateZeroBytes(length);
}

function generateReserved(length) {
  return generateZeroBytes(length);
}

function generateZeroBytes(bytes) {
  return new Uint8Array(bytes);
}

function num2FourBytes(num) {
  return new Uint8Array([num >>> 24 & 0xff, num >>> 16 & 0xff, num >>> 8 & 0xff, num & 0xff]);
}

function num2EightBytes(num) {
  var upper = num / Math.pow(2, 32);
  var lower = num % Math.pow(2, 32);
  return new Uint8Array([upper >>> 24 & 0xff, upper >>> 16 & 0xff, upper >>> 8 & 0xff, upper & 0xff, lower >>> 24 & 0xff, lower >>> 16 & 0xff, lower >>> 8 & 0xff, lower & 0xff]);
}

var ftyp$1 = function ftyp$1() {
  var content = new Uint8Array([0x69, 0x73, 0x6F, 0x6D, // major_brand: isom
  0x00, 0x00, 0x00, 0x01, // minor_version: 0x01
  0x69, 0x73, 0x6F, 0x6D, // isom
  0x61, 0x76, 0x63, 0x31]);
  return generateBox('ftyp', content);
}; // prettier-ignore


var MATRIX_TYPED_ARRAY = new Uint8Array([0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00]);

function mvhd$1(data) {
  var duration = data.duration,
      timescale = data.timescale; // prettier-ignore

  var content = new Uint8Array([0x01, 0x00, 0x00, 0x00, // version、flags
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // creation_time
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00].concat(_toConsumableArray(num2FourBytes(timescale)), _toConsumableArray(num2EightBytes(duration)), [0x00, 0x01, 0x00, 0x00, // 1.0 rate
  0x01, 0x00], _toConsumableArray(generateReserved(10)), _toConsumableArray(MATRIX_TYPED_ARRAY), _toConsumableArray(generatePredefined(24)), [// pre_defined
  0xff, 0xff, 0xff, 0xff // next_track_ID
  ]));
  return generateBox('mvhd', content);
}

function tkhd$1(data) {
  var type = data.type,
      duration = data.duration,
      width = data.width,
      height = data.height; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(1, 7)), [// version & flags
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // creation_time
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], _toConsumableArray(num2FourBytes(type === 'video' ? 1 : 2)), _toConsumableArray(generateReserved(4)), _toConsumableArray(num2EightBytes(duration)), _toConsumableArray(generateReserved(8)), [0x00, 0x00, // layer
  0x00, 0x00, // alternate_group
  0x00, 0x00, // volume
  0x00, 0x00], _toConsumableArray(MATRIX_TYPED_ARRAY), [width >> 8 & 0xff, width & 0xff, 0x00, 0x00, height >> 8 & 0xff, height & 0xff, 0x00, 0x00]));
  return generateBox('tkhd', content);
}

function mdhd$2(data) {
  var type = data.type;
  var duration;
  var timescale;

  if (type === 'video') {
    duration = data.videoDuration;
    timescale = data.videoTimescale;
  } else {
    duration = data.audioDuration;
    timescale = data.audioTimescale;
  } // prettier-ignore


  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(1, 0)), [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // creation_time
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], _toConsumableArray(num2FourBytes(timescale)), _toConsumableArray(num2EightBytes(duration)), [// duration 
  0x55, 0xc4, // language
  0x00, 0x00]));
  return generateBox('mdhd', content);
}

function hdlr$1(type) {
  var handler = '';
  var name = '';

  switch (type) {
    case 'video':
      handler = 'vide';
      name = 'VideoHandler';
      break;

    case 'audio':
      handler = 'soun';
      name = 'SoundHandler';
  } // prettier-ignore


  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), _toConsumableArray(generatePredefined(4)), _toConsumableArray(str2TypedArray(handler)), _toConsumableArray(generateReserved(12)), _toConsumableArray(str2TypedArray(name)), [0x00]));
  return generateBox('hdlr', content);
}

function vmhd$1() {
  // prettier-ignore
  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 1)), [// version(0) + flags
  0x00, 0x00, // graphicsmode: 2 bytes
  0x00, 0x00, 0x00, 0x00, // opcolor: 3 * 2 bytes
  0x00, 0x00]));
  return generateBox('vmhd', content);
}

function smhd$1() {
  // prettier-ignore
  var content = [].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [0x00, 0x00, 0x00, 0x00 // balance(2) + reserved(2)
  ]);
  return generateBox('smhd', content);
}

function dinf() {
  return generateBox('dinf', dref$1());
}

function dref$1() {
  // prettier-ignore
  var content = concatTypedArray(new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [0x00, 0x00, 0x00, 0x01])), url$1());
  return generateBox('dref', content);
}

function url$1() {
  // prettier-ignore
  return generateBox('url ', [0x00, 0x00, 0x00, 0x01]);
}

function avcC$1(data) {
  var SPS = data.SPS,
      PPS = data.PPS; // prettier-ignore

  var content = new Uint8Array([0x01, // configurationVersion
  SPS[1], // AVCProfileIndication
  SPS[2], // profile_compatibility,
  SPS[3], // AVCLevelIndication
  0xfc | 3, // lengthSizeMinusOne`
  0xE0 | 1, // 目前只处理一个sps **
  SPS.length >> 8 & 0xff, SPS.length & 0xff].concat(_toConsumableArray(SPS), [0x01, PPS.length >> 8 & 0xff, PPS.length & 0xff], _toConsumableArray(PPS)));
  return generateBox('avcC', content);
}

function acv1(data) {
  var width = data.width,
      height = data.height; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateReserved(6)), [0x00, 0x01], _toConsumableArray(generatePredefined(16)), [width >> 8 & 0xff, width & 0xff, height >> 8 & 0xff, height & 0xff, // width & height
  0x00, 0x48, 0x00, 0x00, // horizresolution
  0x00, 0x48, 0x00, 0x00], _toConsumableArray(generateReserved(4)), [0x00, 0x01, // frame_count
  0x0B, 0x57, 0x41, 0x4E, 0x47, 0x4C, 0x75, 0x76, 0X44, 0x41, 0x4E, 0x47], _toConsumableArray(generatePredefined(20)), [0x00, 0x18, // depth
  // 设置成 0x00, 0x00 的话 safari 无法正常播放。
  0xff, 0xff]));
  content = concatTypedArray(content, avcC$1(data));
  return generateBox('avc1', content);
}

function esds$1(data) {
  var _data$audioConfig = data.audioConfig,
      config = _data$audioConfig === void 0 ? [43, 146, 8, 0] : _data$audioConfig; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [0x03, // DecoderSpecificInfo
  0x17 + config.length, // length
  0x00, 0x01, // es_id
  0x00, // stream_priority
  0x04, // DecoderConfigDescrTag
  0x0f + config.length, // length
  0x40, // codec
  0x15, // stream_type
  0x00, 0x00, 0x00, // buffer_size
  0x00, 0x00, 0x00, 0x00, // maxBitrate
  0x00, 0x00, 0x00, 0x00, // avgBitrate
  0x05, // DecSpecificInfoTag
  config.length], _toConsumableArray(config), [0x06, 0x01, 0x02]));
  return generateBox('esds', content);
}

function mp4a$1(data) {
  var channelCount = data.channelCount,
      sampleRate = data.sampleRate; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateReserved(6)), [0x00, 0x01], _toConsumableArray(generateReserved(8)), [0x00, channelCount, 0x00, 0x10], _toConsumableArray(generateReserved(4)), [sampleRate >> 8 & 0xFF, // Audio sample rate
  sampleRate & 0xFF, 0x00, 0x00]));
  content = concatTypedArray(content, esds$1(data));
  return generateBox('mp4a', content);
}

function stsd$1(data) {
  var type = data.type;
  var content;

  if (type === 'video') {
    content = acv1(data);
  } else if (type === 'audio') {
    content = mp4a$1(data);
  }

  content = concatTypedArray( // prettier-ignore
  new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [// version & flags
  0x00, 0x00, 0x00, 0x01 // entry_count
  ])), content);
  return generateBox('stsd', content);
}

function stbl(data) {
  var content = concatTypedArray(stsd$1(data), stts$1(), stsc(), stsz(), stco$1());
  return generateBox('stbl', content);
}

var stsz = function stsz() {
  // prettier-ignore
  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [// version(0) + flags
  0x00, 0x00, 0x00, 0x00, // sample_size
  0x00, 0x00, 0x00, 0x00 // sample_count
  ]));
  return generateBox('stsz', content);
};

var stsc = function stsc() {
  // prettier-ignore
  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [// version(0) + flags
  0x00, 0x00, 0x00, 0x00]));
  return generateBox('stsc', content);
};

var stts$1 = function stts$1() {
  // prettier-ignore
  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [// version(0) + flags
  0x00, 0x00, 0x00, 0x00]));
  return generateBox('stts', content);
};

var stco$1 = function stco$1() {
  // prettier-ignore
  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), [// version(0) + flags
  0x00, 0x00, 0x00, 0x00]));
  return generateBox('stco', content);
};

function minf(data) {
  var type = data.type;
  var header = '';

  switch (type) {
    case 'video':
      header = vmhd$1();
      break;

    case 'audio':
      header = smhd$1();
      break;
  }

  var content = concatTypedArray(header, dinf(), stbl(data));
  return generateBox('minf', content);
}

function mdia(data) {
  var content = concatTypedArray(mdhd$2(data), hdlr$1(data.type), minf(data));
  return generateBox('mdia', content);
}

function trak(data) {
  var content = concatTypedArray(tkhd$1(data), mdia(data));
  return generateBox('trak', content);
}

function mvex(data) {
  var content = concatTypedArray(mehd(data), trex(1), trex(2));
  return generateBox('mvex', content);
}

function mehd(data) {
  var duration = data.duration; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), _toConsumableArray(num2FourBytes(duration))));
  return generateBox('mehd', content);
}

function trex(trackId) {
  // prettier-ignore
  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), _toConsumableArray(num2FourBytes(trackId)), [0x00, 0x00, 0x00, 0x01, // default_sample_description_index
  0x00, 0x00, 0x00, 0x00, // default_sample_duration
  0x00, 0x00, 0x00, 0x00, // default_sample_size
  0x00, 0x01, 0x00, 0x01 // default_sample_flags
  ]));
  return generateBox('trex', content);
}

function _moov(data, type) {
  var content = concatTypedArray(mvhd$1(data), trak(_objectSpread({}, data, {
    type: type
  })), mvex(data));
  return generateBox('moov', content);
}

function mfhd(data) {
  var sequenceNumber = data.sequenceNumber; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), _toConsumableArray(num2FourBytes(sequenceNumber))));
  return generateBox('mfhd', content);
}

function tfhd(data) {
  var trackId = data.trackId; // prettier-ignore

  return generateBox('tfhd', new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(0, 0)), _toConsumableArray(num2FourBytes(trackId)))));
}

function sdtp$1(data) {
  var samples = data.samples;
  var content = concatTypedArray.apply(void 0, [[0x00, 0x00, 0x00, 0x00]].concat(_toConsumableArray(samples.map(function () {
    return new Uint8Array([0x10]);
  }))));
  return generateBox('sdtp', content);
}

function tfdt(data) {
  var baseMediaDecodeTime = data.baseMediaDecodeTime; // prettier-ignore

  var content = new Uint8Array([].concat(_toConsumableArray(generateVersionAndFlags(1, 0)), [//  version & flag
  0x00, 0x00, 0x00, 0x00, baseMediaDecodeTime >>> 24 & 0xFF, // baseMediaDecodeTime: int32
  baseMediaDecodeTime >>> 16 & 0xFF, baseMediaDecodeTime >>> 8 & 0xFF, baseMediaDecodeTime & 0xFF]));
  return generateBox('tfdt', content);
}

function trun(data) {
  var samples = data.samples,
      trackId = data.trackId;
  var ceil = trackId === 1 ? 16 : 12;
  var length = samples.length; // mdat-header 8
  // moof-header 8
  // mfhd 16
  // traf-header 8
  // thhd 16
  // tfdt 20
  // trun-header 12
  // sampleCount 4
  // data-offset 4
  // samples.length
  // sdtp-header 12

  var offset = 108 + ceil * length + samples.length; // prettier-ignore

  var content = new Uint8Array([0x00, 0x00, trackId === 1 ? 0x0f : 0x07, 0x01].concat(_toConsumableArray(num2FourBytes(samples.length)), _toConsumableArray(num2FourBytes(offset)), _toConsumableArray(concatTypedArray.apply(void 0, _toConsumableArray(samples.map(function (sample, index) {
    var duration = sample.duration,
        size = sample.size,
        compositionTimeOffset = sample.compositionTimeOffset;
    return concatTypedArray(num2FourBytes(duration), num2FourBytes(size), trackId === 1 ? index === 0 // FIXME:need sample flags
    ? [0x02, 0x00, 0x00, 0x00] : [0x01, 0x01, 0x00, 0x00] : [0x01, 0x00, 0x00, 0x00], trackId === 1 ? num2FourBytes(compositionTimeOffset) : []);
  }))))));
  return generateBox('trun', content);
}

function traf(data) {
  var content = concatTypedArray(tfhd(data), tfdt(data), sdtp$1(data), trun(data));
  return generateBox('traf', content);
}

function _moof(data) {
  var content = concatTypedArray(mfhd(data), traf(data));
  return generateBox('moof', content);
}

function mdat$1(data) {
  return generateBox('mdat', data);
}

var FMP4Generator =
/*#__PURE__*/
function () {
  function FMP4Generator() {
    _classCallCheck(this, FMP4Generator);
  }

  _createClass(FMP4Generator, null, [{
    key: "ftyp",
    value: function ftyp() {
      return ftyp$1();
    }
  }, {
    key: "moov",
    value: function moov(data, type) {
      return _moov(data, type);
    }
  }, {
    key: "moof",
    value: function moof(trackInfo, baseMediaDecodeTime) {
      return _moof(Object.assign({}, trackInfo, {
        sequenceNumber: FMP4Generator.sequenceNumber++,
        baseMediaDecodeTime: baseMediaDecodeTime
      }));
    }
  }, {
    key: "mdat",
    value: function mdat(trackInfo) {
      var samples = trackInfo.samples.map(function (sample) {
        return new Uint8Array(sample.buffer);
      });
      return mdat$1(concatTypedArray.apply(void 0, _toConsumableArray(samples)));
    }
  }]);

  return FMP4Generator;
}();

_defineProperty(FMP4Generator, "sequenceNumber", 1); // copy from https://github.com/google/shaka-player/blob/master/lib/polyfill/mediasource.js#L125


function abortPolyfill() {
  var addSourceBuffer = MediaSource.prototype.addSourceBuffer;

  MediaSource.prototype.addSourceBuffer = function () {
    for (var _len2 = arguments.length, varArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      varArgs[_key2] = arguments[_key2];
    }

    var sourceBuffer = addSourceBuffer.apply(this, varArgs);

    sourceBuffer.abort = function () {}; // Stub out for buggy implementations.


    return sourceBuffer;
  };
}

var MAGIC_NUMBER = 20000;

var MSE =
/*#__PURE__*/
function () {
  function MSE(video, src) {
    var _this4 = this;

    _classCallCheck(this, MSE);

    _defineProperty(this, "installSrc", function () {
      _this4.mediaSource = new MediaSource();

      _this4.mediaSource.addEventListener('sourceopen', _this4.handleSourceOpen);

      _this4.video.src = URL.createObjectURL(_this4.mediaSource);
    });

    _defineProperty(this, "handleSourceOpen", function () {
      _this4.sourceBuffers.video = _this4.mediaSource.addSourceBuffer(_this4.mimeTypes.video);
      _this4.sourceBuffers.audio = _this4.mediaSource.addSourceBuffer(_this4.mimeTypes.audio);

      _this4.sourceBuffers.video.addEventListener('updateend', function () {
        var buffer = _this4.videoQueue.shift();

        if (buffer && _this4.mediaSource.readyState === 'open') {
          _this4.handleAppendBuffer(buffer, 'video');
        }

        if (_this4.needUpdateTime) {
          _this4.needUpdateTime = false;

          _this4.handleTimeUpdate();
        }
      });

      _this4.sourceBuffers.audio.addEventListener('updateend', function () {
        var buffer = _this4.audioQueue.shift();

        if (buffer && _this4.mediaSource.readyState === 'open') {
          _this4.handleAppendBuffer(buffer, 'audio');
        }
      });
    });

    _defineProperty(this, "handleAppendBuffer", function (buffer, type) {
      if (_this4.mediaSource.readyState === 'open') {
        try {
          if (_this4.sourceBuffers[type]) {
            _this4.sourceBuffers[type].appendBuffer(buffer);
          }
        } catch (error) {
          // see https://developers.google.com/web/updates/2017/10/quotaexceedederror
          if (error.code === 22) {
            _this4.handleQuotaExceededError(buffer, type);
          } else {
            throw error;
          }
        }
      } else {
        _this4["".concat(type, "Queue")].push(buffer);
      }
    });

    _defineProperty(this, "hasBufferedCache", function (isSeek) {
      var _this4$mp4Probe$timeR = _slicedToArray(_this4.mp4Probe.timeRange, 2),
          start = _this4$mp4Probe$timeR[0],
          end = _this4$mp4Probe$timeR[1]; // handle seek case and normal case


      var time = isSeek ? _this4.video.currentTime : Math.floor((start + end) / 2);
      var buffered = _this4.video.buffered;

      if (buffered && buffered.length > 0) {
        for (var i = 0; i < buffered.length; i++) {
          if (time >= buffered.start(i) && time <= buffered.end(i)) {
            return true;
          }
        }
      }

      return false;
    });

    _defineProperty(this, "seek", function (time) {
      FragmentFetch.clear();

      var _this4$mp4Probe$getFr = _this4.mp4Probe.getFragmentPosition(time),
          _this4$mp4Probe$getFr2 = _slicedToArray(_this4$mp4Probe$getFr, 2),
          start = _this4$mp4Probe$getFr2[0],
          end = _this4$mp4Probe$getFr2[1]; // 对于已经请求的数据不再重复请求
      // No need to repeat request video data


      if (_this4.hasBufferedCache(time) && !_this4.qualityChangeFlag) {
        return;
      }

      _this4.handleReplayCase();

      _this4.loadData(start, end).then(function (mdatBuffer) {
        if (!mdatBuffer) {
          return;
        }

        var _this4$mp4Probe$getTr = _this4.mp4Probe.getTrackInfo(mdatBuffer),
            videoTrackInfo = _this4$mp4Probe$getTr.videoTrackInfo,
            audioTrackInfo = _this4$mp4Probe$getTr.audioTrackInfo;

        var _this4$mp4Probe = _this4.mp4Probe,
            videoInterval = _this4$mp4Probe.videoInterval,
            audioInterval = _this4$mp4Probe.audioInterval;
        var videoBaseMediaDecodeTime = videoInterval.timeInterVal[0];
        var audioBaseMediaDecodeTime = audioInterval.timeInterVal[0];
        var videoRawData = concatTypedArray(FMP4Generator.moof(videoTrackInfo, videoBaseMediaDecodeTime), FMP4Generator.mdat(videoTrackInfo)); // maybe the last GOP dont have audio track
        // 最后一个 GOP 序列可能没有音频轨

        if (audioTrackInfo.samples.length !== 0) {
          var audioRawData = concatTypedArray(FMP4Generator.moof(audioTrackInfo, audioBaseMediaDecodeTime), FMP4Generator.mdat(audioTrackInfo));

          _this4.handleAppendBuffer(audioRawData, 'audio');
        }

        _this4.handleAppendBuffer(videoRawData, 'video');

        if (time) {
          _this4.needUpdateTime = true;
        }

        _this4.qualityChangeFlag = false;
      });
    });

    _defineProperty(this, "handleTimeUpdate", function () {
      if (!_this4.mp4Probe) {
        return;
      }

      var _this4$mp4Probe2 = _this4.mp4Probe,
          _this4$mp4Probe2$vide = _this4$mp4Probe2.videoInterval;
      _this4$mp4Probe2$vide = _this4$mp4Probe2$vide === void 0 ? [] : _this4$mp4Probe2$vide;
      var _this4$mp4Probe2$vide2 = _this4$mp4Probe2$vide.offsetInterVal,
          offsetInterVal = _this4$mp4Probe2$vide2 === void 0 ? [] : _this4$mp4Probe2$vide2,
          videoSamplesLength = _this4$mp4Probe2.mp4Data.videoSamplesLength,
          _this4$mp4Probe2$time = _this4$mp4Probe2.timeRange,
          timeRange = _this4$mp4Probe2$time === void 0 ? [] : _this4$mp4Probe2$time;

      if (_this4.mediaSource.readyState !== 'closed') {
        if (offsetInterVal[1] === videoSamplesLength && _this4.video.currentTime > timeRange[0]) {
          _this4.destroy();
        } else if (_this4.shouldFetchNextSegment()) {
          _this4.seek();
        }
      }
    });

    _defineProperty(this, "handleReplayCase", function () {
      if (_this4.mediaSource.readyState === 'ended') {
        // If MediaSource.readyState value is ended,
        // setting SourceBuffer.timestampOffset will cause this value to transition to open.
        _this4.sourceBuffers.video.timestampOffset = 0;
      }
    });

    _defineProperty(this, "shouldFetchNextSegment", function () {
      _this4.handleReplayCase();

      if (_this4.mp4Probe.isDraining(_this4.video.currentTime)) {
        return true;
      }

      return false;
    });

    _defineProperty(this, "destroy", function () {
      _this4.mediaSource.removeEventListener('sourceopen', _this4.handleSourceOpen);

      URL.revokeObjectURL(_this4.video.src);

      if (_this4.mediaSource.readyState === 'open' && !_this4.sourceBuffers.video.updating && !_this4.sourceBuffers.audio.updating) {
        _this4.mediaSource.endOfStream();
      }
    });

    _defineProperty(this, "handleQuotaExceededError", function (buffer, type) {
      for (var key in _this4.sourceBuffers) {
        var track = _this4.sourceBuffers[key];
        var currentTime = _this4.video.currentTime;
        var removeStart = 0;

        if (track.buffered.length > 0) {
          removeStart = track.buffered.start(0) + 10;
        }

        _this4.removeBuffer(removeStart, currentTime - 10, key);
      } // re-append(maybe should lower the playback resolution)


      _this4.handleAppendBuffer(buffer, type);
    });

    this.video = video;
    this.src = src;
    this.qualityChangeFlag = false;
    this.videoQueue = [];
    this.audioQueue = [];
    this.sourceBuffers = {
      video: null,
      audio: null
    };
    this.mimeTypes = {
      video: 'video/mp4; codecs="avc1.42E01E"',
      audio: 'audio/mp4; codecs="mp4a.40.2"'
    };
    this.installSrc();
  }

  _createClass(MSE, [{
    key: "init",
    value: function init() {
      var _this5 = this;

      // 获取 mdat 外的数据
      return this.loadData().then(function (res) {
        return new MP4Parse(new Uint8Array(res)).mp4BoxTreeObject;
      }).then(function (mp4BoxTreeObject) {
        // 有可能 moov 在最后一个 box，导致我们第一次请求 0~MAGIC_NUMBER 没有请求到 moov。
        var moov = mp4BoxTreeObject.moov,
            ftyp = mp4BoxTreeObject.ftyp;

        if (!moov) {
          var moovStart = 0;

          for (var box in mp4BoxTreeObject) {
            moovStart += mp4BoxTreeObject[box].size;
          }

          return _this5.loadData(moovStart, '').then(function (res) {
            var moov = new MP4Parse(new Uint8Array(res)).mp4BoxTreeObject.moov;

            if (moov) {
              mp4BoxTreeObject.moov = moov;
              return mp4BoxTreeObject;
            }
          });
        } else {
          // 有可能视频较大，第一次请求没有请求到完整的 moov box
          var ftypAndMoovSize = moov.size + ftyp.size;

          if (ftypAndMoovSize > MAGIC_NUMBER) {
            return _this5.loadData(ftyp.size, ftypAndMoovSize).then(function (res) {
              var moov = new MP4Parse(new Uint8Array(res)).mp4BoxTreeObject.moov;

              if (moov) {
                mp4BoxTreeObject.moov = moov;
                return mp4BoxTreeObject;
              }
            });
          }
        }

        return mp4BoxTreeObject;
      }).then(function (mp4BoxTreeObject) {
        _this5.mp4Probe = new MP4Probe(mp4BoxTreeObject);
        _this5.mp4BoxTreeObject = mp4BoxTreeObject;
        var videoRawData = concatTypedArray(FMP4Generator.ftyp(), FMP4Generator.moov(_this5.mp4Probe.mp4Data, 'video'));
        var audioRawData = concatTypedArray(FMP4Generator.ftyp(), FMP4Generator.moov(_this5.mp4Probe.mp4Data, 'audio')); // 如果是切换清晰度，mediaSource 的 readyState 已经 open 了，可以直接 append 数据。
        // mediaSource is already open when we switch video quality.

        if (_this5.qualityChangeFlag) {
          _this5.handleAppendBuffer(videoRawData, 'video');

          _this5.handleAppendBuffer(audioRawData, 'audio');
        } else {
          _this5.mediaSource.addEventListener('sourceopen', function () {
            _this5.handleAppendBuffer(videoRawData, 'video');

            _this5.handleAppendBuffer(audioRawData, 'audio');
          });
        }
      });
    }
  }, {
    key: "changeQuality",
    value: function changeQuality(newSrc) {
      var _this6 = this;

      this.src = newSrc;
      this.qualityChangeFlag = true; // remove old quality buffer before append new quality buffer

      for (var key in this.sourceBuffers) {
        var track = this.sourceBuffers[key];
        var length = track.buffered.length;

        if (length > 0) {
          this.removeBuffer(track.buffered.start(0), track.buffered.end(length - 1), key);
        }
      }

      this.init().then(function () {
        _this6.video.currentTime = _this6.video.currentTime;
      });
    }
  }, {
    key: "removeBuffer",
    value: function removeBuffer(start, end, type) {
      var track = this.sourceBuffers[type];

      if (track.updating) {
        var _isSafari = ua.isSafari;

        if (_isSafari) {
          // Safari 9/10/11/12 does not correctly implement abort() on SourceBuffer.
          // Calling abort() before appending a segment causes that segment to be
          // incomplete in buffer.
          // Bug filed: https://bugs.webkit.org/show_bug.cgi?id=165342
          abortPolyfill();
        }

        track.abort();
      }

      track.remove(start, end);
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this7 = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAGIC_NUMBER;
      return new Promise(function (resolve) {
        new FragmentFetch(_this7.src, start, end, resolve);
      }).catch(function () {// catch cancel error
      });
    }
  }]);

  return MSE;
}();

var isSafari = ua.isSafari;

var Player =
/*#__PURE__*/
function (_Component) {
  _inherits(Player, _Component);

  function Player() {
    var _getPrototypeOf2;

    var _this8;

    _classCallCheck(this, Player);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this8 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Player)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this8), "useMSE", true);

    _defineProperty(_assertThisInitialized(_this8), "handleTimeUpdate", function (e) {
      if (_this8.useMSE) {
        _this8.mse.handleTimeUpdate();
      }

      _this8.props.onTimeUpdate(e);
    });

    _defineProperty(_assertThisInitialized(_this8), "handleVideoSeeking", function (e) {
      var currentTime = _this8.video.currentTime;
      var buffered = _this8.video.buffered;

      if (isSafari && buffered && buffered.length > 0) {
        if (currentTime - 0.1 > buffered.start(0)) {
          if (_this8.useMSE) {
            _this8.mse.seek(_this8.video.currentTime);
          }
        } else if (currentTime < buffered.start(0)) {
          _this8.handleSafariBug();

          return;
        }
      } else {
        if (_this8.useMSE) {
          _this8.mse.seek(_this8.video.currentTime);
        }
      }

      _this8.props.onSeeking(e);
    });

    _defineProperty(_assertThisInitialized(_this8), "handlePlay", function (e) {
      var currentTime = _this8.video.currentTime;

      if (currentTime === 0 && _this8.useMSE) {
        _this8.mse.seek(0);
      }

      var onPlay = _this8.props.onPlay;

      if (onPlay) {
        onPlay(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this8), "handleVideoProgress", function (e) {
      var buffered = _this8.video.buffered;
      var currentTime = _this8.video.currentTime;

      if (isSafari && buffered && buffered.length > 0 && currentTime < buffered.start(0)) {
        _this8.handleVideoSeeking();
      }

      _this8.props.onProgress(e);
    });

    _defineProperty(_assertThisInitialized(_this8), "handleSafariBug", function () {
      var start = 0;

      if (_this8.video.buffered.length > 0) {
        start = _this8.video.buffered.start(0);
      }

      _this8.video.currentTime = start + 0.1;
    });

    return _this8;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this9 = this;

      this.mse = new MSE(this.video, this.props.src);
      this.mse.init().then(function () {
        // don't use MSE If the video don't have a video track
        if (!_this9.mse.mp4Probe.mp4Data.videoDuration) {
          _this9.useMSE = false;
          _this9.video.src = _this9.props.src;
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.src !== prevProps.src && this.useMSE) {
        this.mse.changeQuality(this.props.src);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.useMSE) {
        this.mse.destroy();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          src = _this$props.src,
          onRef = _this$props.onRef,
          currentQuality = _this$props.currentQuality,
          onSeeking = _this$props.onSeeking,
          onPlay = _this$props.onPlay,
          paused = _this$props.paused,
          onTimeUpdate = _this$props.onTimeUpdate,
          onProgress = _this$props.onProgress,
          props = _objectWithoutProperties(_this$props, ["src", "onRef", "currentQuality", "onSeeking", "onPlay", "paused", "onTimeUpdate", "onProgress"]);
      /* eslint-enable no-unused-vars */


      return React.createElement("video", _extends({
        ref: function ref(el) {
          _this10.video = el;
          onRef(el);
        }
      }, props, {
        onSeeking: this.handleVideoSeeking,
        onTimeUpdate: this.handleTimeUpdate,
        onPlay: this.handlePlay,
        onProgress: this.handleVideoProgress
      }));
    }
  }]);

  return Player;
}(Component);

var index = {
  pluginName: 'griffith-mp4',
  VideoComponent: Player,
  willHandleSrcChange: true
};
export default index;